export default __webpack_public_path__ + "static/media/breakout_main.41017335.png";